// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"LazyImage_imageWrapper__2t5mw","lazyImage":"LazyImage_lazyImage__25caq"};